<template>
    <section v-if="items.length > 0" class="tours-carousel">
        <div class="component-header container hd-container">
            <h2 class="headline-1"><NuxtLink :to="url">Itineraries</NuxtLink></h2>
            <NuxtLink :to="url" class="view-all">View All</NuxtLink>
        </div>
        <div class="hd-container">
            <GlobalCarousel padding="20%" :items="items">
                <template #item="item">
                    <CardsTour :item="item" />
                </template>
            </GlobalCarousel>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        items: {
            type: Array,
            required: true,
            default: [],
        },
    });

    const { items } = toRefs(props);

    const route = useRoute();
    const url = computed(() => {
        if (route.path.includes('archive')) return '/archive/2023/tours/';
        else return '/itineraries/';
    });
</script>

<style lang="scss">
    .tours-carousel {
        padding: 0 0 60px 0;
    }
</style>
